import { Injectable } from '@angular/core';
import { Router } from '@angular/router';
import { CanActivate, ActivatedRouteSnapshot, RouterStateSnapshot } from '@angular/router';
import { Observable } from 'rxjs/Observable';

@Injectable()
export class RecuperarCuentaGuard implements CanActivate {

	constructor(
		private router: Router
	) {}

  canActivate(next: ActivatedRouteSnapshot, state: RouterStateSnapshot): Observable<boolean> | Promise<boolean> | boolean {
  	const identificacion = localStorage.getItem('identificacion');
  	const medios = localStorage.getItem('medios-comunicacion');
  	if (!identificacion || !medios) {
  		this.router.navigate(['/recuperar-cuenta/autenticacion']);
  		return false;
  	}
    return true;
  }  
}



// WEBPACK FOOTER //
// C:/Users/whuerfanoh/Documents/VSCode Projects/ng_identidadlogin/webapp/src/app/resources/guards/recuperar-cuenta.guard.ts